/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  function initSliders() {
    let flickers = [];
    const carousels = document.querySelectorAll("[data-myflickity]");
    if (carousels) {
      carousels.forEach(function (el) {
        // Initialize Flickity with custom buttons
        if (Flickity.data(el)) {
          return;
        }
        const instance = new Flickity(el, JSON.parse(el.dataset.myflickity));
        flickers.push(instance);
      });
    }
    return flickers;
  }

  let flickers = initSliders();

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        flickers = initSliders();
      }
    }
  });

  const collectionSection = document.querySelector(".collection[data-section-id]");
  if (collectionSection) {
    observer.observe(collectionSection, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  }

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Debounced resize
  window.addEventListener(
    "resize",
    debounce(() => {
      // flkty.resize does not seem to calculate height properly after resize.  so we're manually setting height

      flickers.forEach(function (flkty) {
        flkty.viewport.style.height = flkty.size.innerHeight + "px";
      });
    }, 200),
  ); // Adjust delay (e.g., 200ms) as needed

  // Products tagged _badge_sale:xx have no real compare at price, so
  // snippets/product-price.liquid renders <s data-sale-perc="xx"> with a derived one.
  // Recalculate it whenever the selected variant changes.
  function updateDerivedComparePrice(container, variant) {
    const strikes = container.querySelectorAll("s[data-sale-perc]");

    strikes.forEach(function (strike) {
      const perc = parseFloat(strike.dataset.salePerc);
      const wrap = strike.closest(".product__price__wrap") || container;
      const badge = wrap.querySelector("[data-sale-perc-badge]");

      if (!variant || isNaN(perc) || perc <= 0 || perc >= 100) {
        strike.classList.add("hidden");
        if (badge) badge.classList.add("hidden");
        return;
      }

      if (badge) badge.classList.remove("hidden");

      const compareAtPrice = Math.round((variant.price * 100) / (100 - perc));

      strike.innerHTML = window.themeVendor.themeCurrency.formatMoney(
        compareAtPrice,
        window.theme.moneyFormat,
      );
      strike.classList.remove("hidden");
    });
  }

  document.addEventListener("theme:variant:change", function (event) {
    updateDerivedComparePrice(event.target, event.detail.variant);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
